import React, { useState,Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Description from "./components/Description";
import "./App.css";
const Terms = React.lazy(() => import("./components/Terms"));
const Privacy = React.lazy(() => import("./components/Privacy"));

const VinylPlayer = React.lazy(() => import("./components/VinylPlayer")); 

const App = () => {
  const [videoUrl, setVideoUrl] = useState("");
  const [videoId, setVideoId] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);

  const handleVideoUrlChange = (e) => {
    setVideoUrl(e.target.value);
  };

  const handleLoadVideo = () => {
    const id = extractVideoId(videoUrl);
    if (id) {
      setVideoId(id);
    } else {
      alert("Invalid YouTube URL. Please try again.");
    }
  };

  const extractVideoId = (url) => {
    const regex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|embed|watch)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const handlePlayerStateChange = (event) => {
    setIsPlaying(event.data === 1); 
  };

  return (
    <Router>
      <div id="app-container">
        <div id="main-content">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Helmet>
                  <title>LoopTube - Vinyl-Style YouTube Loop Player</title>
                  <meta
                    name="description"
                    content="LoopTube is the YouTube video looper with a spinning vinyl record design. Set custom loop start/end points and watch the vinyl spin as your video repeats. Free, no sign-up."
                  />
                  <link rel="canonical" href="https://looptube.org/" />
                </Helmet>
                <form
                  className="url-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleLoadVideo();
                  }}
                >
                  <label htmlFor="youtube-url" className="sr-only">
                    YouTube video URL
                  </label>
                  <input
                    id="youtube-url"
                    type="text"
                    placeholder="Paste YouTube URL here"
                    className="url-input"
                    value={videoUrl}
                    onChange={handleVideoUrlChange}
                  />
                  <button type="submit" className="load-button">
                    Load
                  </button>
                </form>
                <Suspense fallback={<p className="route-loading">Loading player…</p>}>
                  <VinylPlayer
                    videoId={videoId || "dQw4w9WgXcQ"}
                    isPlaying={isPlaying}
                    onStateChange={handlePlayerStateChange}
                  />
                </Suspense>
                <Description />
              </>
            }
          />
          <Route
            path="/terms"
            element={
              <Suspense fallback={<p className="route-loading">Loading terms…</p>}>
                <Terms />
              </Suspense>
            }
          />
          <Route
            path="/privacy"
            element={
              <Suspense fallback={<p className="route-loading">Loading privacy policy…</p>}>
                <Privacy />
              </Suspense>
            }
          />
        </Routes>
        </div>
        <footer id="footer">
          <nav id="footer-nav">
            <Link to="/">Home</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/privacy">Privacy</Link>
            <a href="mailto:support@looptube.org" target="_blank" rel="noopener noreferrer">
              Contact
            </a>
          </nav>
          <p className="footer-text">© {new Date().getFullYear()} LoopTube.org. All Rights Reserved.</p>
        </footer>
      </div>
    </Router>
  );
};

export default App;
